import { render, staticRenderFns } from "./videoAndText.vue?vue&type=template&id=0015dcd7&scoped=true&"
import script from "./videoAndText.vue?vue&type=script&lang=js&"
export * from "./videoAndText.vue?vue&type=script&lang=js&"
import style0 from "./videoAndText.vue?vue&type=style&index=0&id=0015dcd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0015dcd7",
  null
  
)

export default component.exports